import { ListActionsAndIssuesGraphRequest_TargetSchema } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { create } from '@bufbuild/protobuf';
import type { ListActionsAndIssuesGraphRequest_Target } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { MetricType } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/metrics_pb';
import { MetricDataSet } from '~/pages/Metrics/types';

export function createSystemBehaviourTargets(
  data: MetricDataSet,
): ListActionsAndIssuesGraphRequest_Target[] {
  return data
    .filter(
      (item): item is Required<MetricDataSet[number]> => !!item.metricType,
    )
    .map(({ resourceName, metricType }) =>
      create(ListActionsAndIssuesGraphRequest_TargetSchema, {
        resourceName,
        types: [MetricType[metricType]],
      }),
    );
}
